import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { FaCheckCircle } from "react-icons/fa";
import { IoMdArrowRoundForward } from "react-icons/io";
import { RACE_DATE_LABEL, RACE_YEAR } from "../data/EventConfig";

const Section = styled.section`
  background: linear-gradient(180deg, #fff8e1 0%, #ffce2d 100%);
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8rem 1.5rem 4rem;
`;

const Card = styled.div`
  background: #fff;
  border-radius: 24px;
  max-width: 560px;
  width: 100%;
  padding: 2.5rem 2rem;
  box-shadow: 0 30px 60px -20px rgba(10, 42, 74, 0.25);
  text-align: center;
`;

const IconWrap = styled.div`
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: rgba(34, 139, 34, 0.12);
  color: #1a7a3a;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 1.25rem;
`;

const Title = styled.h1`
  color: #0a2a4a;
  font-size: clamp(1.6rem, 4vw, 2rem);
  font-weight: 800;
  margin: 0 0 0.75rem;
`;

const Text = styled.p`
  color: rgba(10, 42, 74, 0.85);
  font-size: 1rem;
  line-height: 1.55;
  margin: 0 0 0.75rem;
`;

const Highlight = styled.div`
  background: #fff8e1;
  border: 1px solid rgba(255, 206, 45, 0.5);
  border-radius: 14px;
  padding: 0.85rem 1rem;
  margin: 1.25rem 0;
  color: #0a2a4a;
  font-weight: 700;
`;

const Back = styled(Link)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  background: #faa71e;
  color: #fff;
  padding: 0.75rem 1.25rem;
  border-radius: 999px;
  font-weight: 700;
  font-size: 0.95rem;
  line-height: 1.2;
  white-space: nowrap;
  text-decoration: none;
  margin-top: 0.5rem;
  box-shadow: 0 12px 24px rgba(250, 167, 30, 0.35);
  transition: transform 0.2s ease;

  &:hover {
    transform: translateY(-2px);
  }

  @media (max-width: 480px) {
    font-size: 0.88rem;
    padding: 0.65rem 1rem;
    gap: 0.4rem;
  }
`;

const ThankYou = () => {
  return (
    <Section>
      <Card>
        <IconWrap>
          <FaCheckCircle size={48} />
        </IconWrap>
        <Title>Mulțumim pentru donație!</Title>
        <Text>
          Plata a fost procesată cu succes. Verifică-ți adresa de email — vei
          primi în câteva minute biletele cu numerele alocate, atașate ca
          imagini.
        </Text>
        <Highlight>Ne vedem la cursă: {RACE_DATE_LABEL}</Highlight>
        <Text>
          Dacă nu primești emailul în maxim 30 de minute, verifică folderul
          Spam sau scrie-ne la{" "}
          <a href="mailto:clubrotaract.timisoara@gmail.com" style={{ color: "#0a2a4a" }}>
            clubrotaract.timisoara@gmail.com
          </a>
          .
        </Text>
        <Back to="/">
          Înapoi la pagina principală <IoMdArrowRoundForward />
        </Back>
        <Text style={{ marginTop: "1.5rem", fontSize: "0.78rem", opacity: 0.6 }}>
          Cursa de Rățuște pe Bega · Ediția {RACE_YEAR}
        </Text>
      </Card>
    </Section>
  );
};

export default ThankYou;
